/** @jsx jsx */
import LinkGlyph from '@atlaskit/icon/glyph/link';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import React, { useMemo } from 'react';
import { ExpandedFrame } from '../../components/ExpandedFrame';
import { ImageIcon } from '../../components/ImageIcon';
import { containerStyles, contentStyles, descriptionStyles, imageStyles, titleStyles } from './styled';
const UnresolvedView = ({
  button,
  description,
  frameStyle,
  icon: iconUrlOrElement,
  image,
  inheritDimensions,
  isSelected,
  onClick,
  testId,
  text,
  title,
  url
}) => {
  const icon = useMemo(() => {
    if ( /*#__PURE__*/React.isValidElement(iconUrlOrElement)) {
      return iconUrlOrElement;
    }
    return jsx(ImageIcon, {
      src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
      default: jsx(LinkGlyph, {
        label: "icon",
        size: "small",
        testId: "embed-card-fallback-icon"
      })
    });
  }, [iconUrlOrElement]);
  return jsx(ExpandedFrame, {
    allowScrollBar: true
    // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
    // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
    // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
    // We want all views to be consistent and respect frameStyle instead of
    // having resolved view default to showOnHover and unresolved view default to show.
    // Default frameStyle is set inside <ExpandedFrame />
    ,
    frameStyle: frameStyle !== null && frameStyle !== void 0 ? frameStyle : 'show',
    href: url,
    icon: icon,
    inheritDimensions: inheritDimensions,
    isSelected: isSelected,
    onClick: onClick,
    testId: testId,
    text: text
  }, jsx("div", {
    css: containerStyles,
    "data-testid": `${testId}-unresolved-container`
  }, jsx("div", {
    css: contentStyles
  }, jsx("img", {
    css: imageStyles,
    "data-testid": `${testId}-unresolved-image`,
    src: image
  }), jsx("h2", {
    css: titleStyles,
    "data-testid": `${testId}-unresolved-title`
  }, title), jsx("span", {
    css: descriptionStyles,
    "data-testid": `${testId}-unresolved-description`
  }, description), button)));
};
export default UnresolvedView;